import { store } from '@betacrew/jars-flux';
import { all, put, takeLatest } from 'redux-saga/effects';
import { addNotifications } from '../../../toaster/ToasterPortalSlice';
import { TOASTER_VARIANT } from '../../../../components/toast/constants';
import RecipientDataService from '../../../../../services/RecipientDataService';
import Payer from '../../../../../libs/utility/Payer';
import { componentKey, setBulkW8RequestConfirmationModal, setBuyingPlan, setEstimedTaxModalOpen, setGetW8FormsModalOpen, setHasEnoughRequests, setLoadingState, setPayWithPrepayModalOpen, setPrepayRequestModalOpen, setProceedWithW8RequestModalOpen, setRequestedCount, setW8Fees, setW8Forms, setW8RequestedCountModalOpen } from './BulkW8RequestModalSlice';
import { W8_MODALS_LOADING_STATES } from './constants';
import { setShouldReloadPaginatedRecipientList } from '../RecipientListSlice';

export const { getW8Forms, isDisplayPlansView, getW8RequestedCount, getW8Fees, requestBulkW8 } = {

    getW8Forms: (payload) => {
        return {
            type: "W8_REQUEST/GET_W8_FORMS",
            payload
        }
    },

    isDisplayPlansView: (payload) => {
        return {
            type: "W8_REQUEST/IS_DISPLAY_PLANS_VIEW",
            payload
        }
    },

    getW8RequestedCount: (payload) => {
        return {
            type: "W8_REQUEST/GET_W8_REQUESTED_COUNT",
            payload
        }
    },

    getW8Fees: (payload) => {
        return {
            type: "W8_REQUEST/GET_W8_FEES",
            payload
        }
    },

    requestBulkW8: (payload) => {
        return {
            type: "W8_REQUEST/REQUEST_BULK_W8",
            payload
        }
    },

}

function* getW8FormsAsync(action) {
    try {
        yield put(setLoadingState({ state: W8_MODALS_LOADING_STATES.FETCH_W8_FORMS_LOADING }))

        const { RecipientIds, isSelectAll } = action.payload;
        const response = yield RecipientDataService.getW8Forms();

        const { Data, Message, Status } = response?.data;

        if (Status) {

            const W8forms = Data.map(item => {
                return { value: item, label: item }
            })

            yield put(isDisplayPlansView({ RecipientIds, isSelectAll }));

            yield put(setW8Forms(W8forms))
        } else {
            yield put(addNotifications({ heading: "Failed to get W8 Forms", message: Message }));
        }

    } catch (error) {
        console.log('err: ', error)
        yield put(addNotifications({ heading: "Failed to get W8 Forms", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: W8_MODALS_LOADING_STATES.FETCH_W8_FORMS_READY }))
    }

}

function* isDisplayPlansViewAsync(action) {
    try {
        yield put(setLoadingState({ state: W8_MODALS_LOADING_STATES.DISPLAY_PLANS_VIEW_LOADING }));

        const { RecipientIds, isSelectAll } = action.payload;

        const response = yield RecipientDataService.isDisplayPlansView();

        const { Data, Message, Status } = response?.data;

        if (Status) {
            if (Data) {
                yield put(setHasEnoughRequests(true))
                yield put(setGetW8FormsModalOpen(true));
                yield put(setBuyingPlan(false));
            } else {
                yield put(setHasEnoughRequests(false))
                if (RecipientIds?.length > 1 || isSelectAll) {
                    yield put(setPrepayRequestModalOpen(true));
                    yield put(setBuyingPlan(true));
                } else {
                    yield put(setGetW8FormsModalOpen(true));
                    yield put(setBuyingPlan(false));
                }
            }

            yield put(setW8RequestedCountModalOpen(false))
            yield put(setBulkW8RequestConfirmationModal(false))
            return;
        } else {
            yield put(addNotifications({ heading: "Failed to get display plans", message: Message }));
            yield put(setLoadingState({ state: W8_MODALS_LOADING_STATES.DISPLAY_PLANS_VIEW_READY }))
        }

    } catch (error) {
        console.log('err: ', error)
        yield put(addNotifications({ heading: "Failed to get display plans", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: W8_MODALS_LOADING_STATES.DISPLAY_PLANS_VIEW_READY }))
    }

}

function* getW8RequestedCountAsync(action) {
    try {
        yield put(setLoadingState({ state: W8_MODALS_LOADING_STATES.GET_W8_REQUEST_COUNT_LOADING }))

        const { PayerID, RecipientIds, IsAllSelect } = action.payload;

        const data = {
            PayerID: PayerID || "",
            RecipientIds: RecipientIds || [],
            IsAllSelect: IsAllSelect,
        }

        const response = yield RecipientDataService.getW8RequestedCount(data);

        const { Data, Message, Status } = response?.data;

        if (Status) {

            yield put(setRequestedCount({
                bulkW8Requests: Data,
                AcceptedW8Requests: Payer.extractNumberFromW8W9Message(Message) || 0
            }))
            yield put(setW8RequestedCountModalOpen(true))
            yield put(setBulkW8RequestConfirmationModal(false))
        } else {
            yield put(addNotifications({ heading: "Failed to get the requested Count" }));
        }

    } catch (error) {
        console.log('err: ', error)
        yield put(addNotifications({ heading: "Failed to get the requested Count", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: W8_MODALS_LOADING_STATES.GET_W8_REQUEST_COUNT_READY }))
    }

}

function* getW8FeesAsync(action) {

    try {
        yield put(setLoadingState({ state: W8_MODALS_LOADING_STATES.GET_W8_FEES_LOADING }));

        const { count } = action.payload;

        const response = yield RecipientDataService.getW8W9Fees(count);

        const { Data, Message, Status } = response?.data;

        if (Status) {
            yield put(setW8Fees(Data));
        } else {
            yield put(addNotifications({ heading: "Failed to get the W8 fees", message: Message }));
        }

    } catch (error) {
        console.log('err: ', error)
        yield put(addNotifications({ heading: "Failed to get the W8 fees", message: error?.response?.data?.Message }));
    } finally {
        yield put(setProceedWithW8RequestModalOpen(false));
        yield put(setLoadingState({ state: W8_MODALS_LOADING_STATES.GET_W8_FEES_READY }));
    }
}

function* requestBulkW8Async(action) {
    try {
        yield put(setLoadingState({ state: W8_MODALS_LOADING_STATES.REQUEST_BULK_W8_LOADING }))
        const {
            RecipientIds = [],
            FormType = "W8-BEN",
            CommonCardHolderName = "",
            CommonCreditCardNumber = "",
            CommonCvvNumber = "",
            CommonExpiryMonth = "",
            CommonExpiryYear = "",
            TotalFee = "",
            Cardtype = "",
            Coupon = "",
            PrepaidAmount = "",
            commonisSaveCard = true,
            CommonSavedCard = null,
            w8W9PlanType = "",
            PaymentEmail = "",
            CommonBillingaddress = "",
            CommonCity = "",
            CommonZipcode = "",
            CommonState = "",
            CommonCountry = "",
            CommonContactEmail = "",
            isW8orW9Payment = "",
            IsBulkTin = "",
            totalAmount = "",
            prepay = "",
            showAdminAmount = "",
            saveCardId = "",
            saveCard = "",
            isPrepaid = "true",
            prepayless1 = "No",
            prepayFlag = "Yes",
            payerId = "",
            isAccountant = "true", // for prepay it is true otherwise false
            selectAll = "", // true if all are selected else false
            payWithPrepayModalOpen, 
            displayPlansView,
            //below fields are not being used in the payload but these fields might be used in future
            payername = "",
            IsautorenewChecked = false,
            adminuserPayment = true,
            SalesTaxAmount = 10.99,
            FillingAmount = 20.99,
            w9PdfImportPrepayLbl = "Prepaid",
            TotalAmount = 100.99,
            planPlanType = "",
            CheckPrepay = "",
            TotalPrepayamount = "",
            IsPrepaid = true,
            StateCodes = null,
            isW8orW9Email = "",
            requestBalance = "",
            CountryCodes = null,
            HiddenTotalFee = "",
            AllSelected = true,
            IsNoticeChecked = true,
        } = action.payload

        const data = {
            RecipientIds,
            FormType,
            w8W9PlanType,
            isW8orW9Payment,
            CommonCardHolderName,
            CommonCreditCardNumber,
            CommonCvvNumber,
            CommonExpiryMonth,
            CommonExpiryYear,
            TotalFee,
            Cardtype,
            Coupon,
            PrepaidAmount,
            commonisSaveCard,
            CommonSavedCard,
            PaymentEmail,
            CommonBillingaddress,
            CommonCity,
            CommonZipcode,
            CommonState,
            CommonCountry,
            CommonContactEmail,
            IsBulkTin,
            totalAmount,
            prepay,
            showAdminAmount,
            saveCardId,
            saveCard,
            isPrepaid,
            prepayless1,
            prepayFlag,
            payerId,
            selectAll,
            isAccountant
        }
        const response = yield RecipientDataService.requestBulkW8(data);
        if (response?.data) {
            const { Status, Message } = response?.data;
            if (Status) {

                if (displayPlansView) {
                    yield put(setShouldReloadPaginatedRecipientList(true));
                    yield put(addNotifications({ heading: "Success", message: "Bulk W8 request successful.", variant: TOASTER_VARIANT.SUCCESS }));
                }
                yield put(setProceedWithW8RequestModalOpen(false))
                if (payWithPrepayModalOpen) {
                    yield put(setPayWithPrepayModalOpen(false))
                    yield put(getW8Forms())
                    yield put(setEstimedTaxModalOpen(false))
                }
            } else {
                yield put(addNotifications({ heading: "Warning", message: Message, variant: TOASTER_VARIANT.WARNING }));
            }
        }
    } catch (error) {
        console.log('err: ', error)
        yield put(addNotifications({ heading: "Failed to get the Prepaid Amount", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: W8_MODALS_LOADING_STATES.REQUEST_BULK_W8_READY }))
    }
}

function* rootSaga() {
    yield all([
        takeLatest(getW8Forms().type, getW8FormsAsync),
        takeLatest(isDisplayPlansView().type, isDisplayPlansViewAsync),
        takeLatest(getW8RequestedCount().type, getW8RequestedCountAsync),
        takeLatest(getW8Fees().type, getW8FeesAsync),
        takeLatest(requestBulkW8().type, requestBulkW8Async),
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);